import { render } from "./ProjectManagement.vue?vue&type=template&id=44add5b2&scoped=true"
import script from "./ProjectManagement.vue?vue&type=script&lang=js"
export * from "./ProjectManagement.vue?vue&type=script&lang=js"

import "./ProjectManagement.vue?vue&type=style&index=0&id=44add5b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44add5b2"]])

export default __exports__